export const MIXPANEL_DRAWER_SOURCE = 'Gig checkout drawer';
